import proj4 from 'proj4';

import { get, transform, transformExtent } from 'ol/proj';
import { register as registerProj4 } from 'ol/proj/proj4';
import { getDistance } from 'ol/sphere';

const register = (crs, wkt) => {
	proj4.defs(crs, wkt);       
	registerProj4(proj4);
}

const haversineDistance = (sourceCoordinate, targetCoordinate, projection) => {
   	const source = transform(sourceCoordinate, projection, 'EPSG:4326');
    const target = transform(targetCoordinate, projection, 'EPSG:4326');

	return getDistance(source, target);	
}

const projection = {
	get, transform, transformExtent, register, haversineDistance
};

export {
	projection, haversineDistance
}